import React from 'react';
import { AIChatPlayground } from '../private/components/AIChatPlayground/AIChatPlayground';
import { IMaterialInfo, IMaterialSolutionSubmission, IMaterialStatus } from '../../api/private/learn-engine-api/learn-engine-api.interface';
import { aIChatPlaygroundContext } from '../private/aIChatPlaygroundConstants';
import { useComponentWillMount } from '../../shared/public/SlUtils/useComponentWillMount';

interface ISlAIChatPlaygroundProps {
	data: IMaterialInfo,
	solveMaterialCallback: (
		statusChanges: IMaterialStatus[],
		solutions: IMaterialSolutionSubmission[],
		materialInfo?: IMaterialInfo,
	) => void,
	lessonSessionGuId: string
}

export const SlAIChatPlayground = ({ data, solveMaterialCallback, lessonSessionGuId }: ISlAIChatPlaygroundProps) => {
	useComponentWillMount(() => {
		aIChatPlaygroundContext.setValue(`aIChatPlaygroundContext_${data.header.materialRelationId}_${lessonSessionGuId}`);
	});

	return (
		<AIChatPlayground
			data={data}
			solveMaterialCallback={solveMaterialCallback}
		/>
	);
};
